import { RouteConfig } from 'vue-router'

const List = () => import('../../views/physical-meet-standard/List.vue')

export const ListRoute: RouteConfig = {
  path: '/physical-meet-standard/list',
  name: 'physical_meet_standard_list',
  component: List,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体测达标计划',
  },
}

export default [ListRoute]
